import {
  Box,
  Grid,
  makeStyles,
  Tooltip,
  Typography,
  useTheme
} from '@material-ui/core'
import { green, grey, amber, red } from '@material-ui/core/colors'
import React from 'react'

const getColorByStatus = status => {
  switch (status) {
    case 'good':
      return green[800]
    case 'medium':
      return amber.A400
    case 'bad':
      return red[800]
    case 'really_bad':
      return grey[900]
    default:
      return grey[900]
  }
}

const useStyles = makeStyles(theme => ({
  roundedStatus: props => ({
    borderRadius: '50%',
    width: props.width || theme.spacing(2),
    height: props.height || theme.spacing(2),
    backgroundColor: props.backgroundColor
  })
}))

const VisualizadorStatus = ({ titulo, status, mensagemAlerta = '', size }) => {
  const theme = useTheme()
  const statusColor = getColorByStatus(status)
  const sizes = {
    small: {
      width: theme.spacing(1),
      height: theme.spacing(1),
      variant: 'caption'
    },
    medium: {
      width: theme.spacing(2),
      height: theme.spacing(2),
      variant: 'body1'
    },
    large: {
      width: theme.spacing(3),
      height: theme.spacing(3),
      variant: 'h6'
    }
  }

  const variantesTamanho = size ? sizes[size] : sizes.medium

  const classes = useStyles({
    backgroundColor: statusColor,
    ...variantesTamanho
  })

  return (
    <Grid container spacing={1} alignItems="center">
      <Grid item xs="auto">
        <Tooltip placement="top" title={mensagemAlerta}>
          <Box className={classes.roundedStatus} />
        </Tooltip>
      </Grid>
      <Grid item xs>
        <Typography variant={variantesTamanho.variant}>{titulo}</Typography>
      </Grid>
    </Grid>
  )
}

export default VisualizadorStatus
